export default __webpack_public_path__ + "de13ec891ebf2ad197ced48733fb6a37.png";